import { atom, selector } from 'recoil';

export interface CurriculumSelection {
  organisation: {
    organisation_id: string;
    name: string;
  } | null;
  board: string;
  classVal: string;
  subject: string;
}

export const curriculumSelectionAtom = atom<CurriculumSelection>({
  key: 'curriculumSelectionAtom',
  default: {
    organisation: null,
    board: '',
    classVal: '',
    subject: '',
  },
});

export const knowledgeMapsAtom = atom<any[]>({
  key: 'knowledgeMapsAtom',
  default: [],
});

export const hasFullSelectionSelector = selector<boolean>({
  key: 'hasFullSelectionSelector',
  get: ({ get }) => {
    const { organisation, board, classVal, subject } = get(curriculumSelectionAtom);
    return Boolean( organisation?.organisation_id && board && classVal && subject);
  },
});